import type { User } from 'oidc-client-ts'

export const isAdmin = (user?: User | null) => {
  if (!user) return undefined
  const roles = (user.profile.organization && user?.profile?.role) as {
    name: string
  }[]
  return roles.find((role: { name: string }) => role.name === 'Admin')
}
